import React from "react";
import { useParams } from "react-router-dom";
import { AvrJournal } from "../../myDocuments/avrJournal";

const ContragentAvr = ({ remont_id: remontIdProp }) => {
  const { remont_id: remontIdParam } = useParams();
  const remont_id = Number(remontIdProp ?? remontIdParam) || null;

  if (!remont_id) return null;
  return <AvrJournal remontId={remont_id} />;
};

export default ContragentAvr;
